interface ResizeHandleProps {
  onPointerDown: (e: React.PointerEvent) => void
  onPointerMove: (e: React.PointerEvent) => void
  onPointerUp: (e: React.PointerEvent) => void
  onPointerCancel: (e: React.PointerEvent) => void
}

export default function ResizeHandle({
  onPointerDown,
  onPointerMove,
  onPointerUp,
  onPointerCancel
}: ResizeHandleProps) {
  return (
    <div
      className="resize-handle icon icon-angle-right"
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
      onPointerCancel={onPointerCancel}
    />
  )
}
